var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 0H1.375C0.61875 0 0 0.61875 0 1.375V9.625C0 10.3813 0.61875 11 1.375 11H9.625C10.3813 11 11 10.3813 11 9.625V1.375C11 0.61875 10.3813 0 9.625 0ZM5.50688 8.9375C5.10125 8.9375 4.785 8.61437 4.785 8.21562C4.785 7.81 5.10813 7.50062 5.50688 7.50062C5.9125 7.50062 6.22188 7.81 6.22188 8.21562C6.215 8.61437 5.9125 8.9375 5.50688 8.9375ZM7.22563 4.69562C6.7925 5.335 6.38 5.5275 6.15312 5.94C6.06375 6.105 6.02938 6.215 6.02938 6.75125H4.98438C4.98438 6.46937 4.94313 6.00875 5.16313 5.61688C5.445 5.115 5.97438 4.81937 6.28375 4.37937C6.61375 3.91187 6.42813 3.04562 5.5 3.04562C4.895 3.04562 4.5925 3.50625 4.46875 3.89125L3.52688 3.49938C3.78813 2.7225 4.4825 2.0625 5.49312 2.0625C6.33875 2.0625 6.92312 2.4475 7.21875 2.92875C7.47313 3.34813 7.6175 4.11812 7.22563 4.69562Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.7da2d5e395ffe083a553cdc7d73fd64d.svg";
export { ForwardRef as ReactComponent };